"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onCardClick = exports.goTo = void 0;
const goTo = (url) => {
    window.open(url);
};
exports.goTo = goTo;
const onCardClick = (name, currentTool, url) => {
    if (name !== currentTool)
        (0, exports.goTo)(url);
};
exports.onCardClick = onCardClick;
